import { ComumHttpService } from '../../comum-http.service';
import { TipoTelefone } from '../../modelos/tipo-telefone';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Telefone } from './../../modelos/telefone';

@Component({
  selector: 'app-form-telefone',
  templateUrl: './form-telefone.component.html',
  styleUrls: ['./form-telefone.component.css']
})
export class FormTelefoneComponent implements OnInit {

  tiposTelefone: TipoTelefone[];

  public ramalMask = [/\d/, /\d/, /\d/, /\d/];

  @Input() telefone: Telefone;
  @Input() modo: string;

  @Output() telefoneEvent: EventEmitter<string>;

  constructor(private _comumHttpService: ComumHttpService) {
    this.telefoneEvent = new EventEmitter<string>();
  }

  ngOnInit() {
    this._comumHttpService.obterTiposTelefoneHttp()
      .subscribe((tiposTelefone: TipoTelefone[]) => {
        this.tiposTelefone = tiposTelefone;
      });
  }

  telefoneMask(rawValue): any {
    const numbers = rawValue.match(/\d/g);
    let numberLength = 0;

    if (numbers) {
      numberLength = numbers.join('').length;
    }

    if (numberLength > 10) {
      return ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    } else {
      return ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    }

  }

  selecionarTipoTelefone(idTipoTelefone: number): void {
	  this.tiposTelefone.forEach(tipoTelefone => {
		if (idTipoTelefone.toString() === tipoTelefone.idTipoTelefone.toString()) {
			this.telefone.tipoTelefone = tipoTelefone;
		}
	  });
  }

  emit(): void {
    this.telefoneEvent.emit('formul&aacute;rio completo');
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/components/form-telefone/form-telefone.component.ts